import React, { Component } from "react";
import NumKeyPad from "./03-ShortTermMemory-KeyPad";
import TextEntry from "./03-ShortTermMemory-TextEntry";
import * as pageData from "./PageData";

const displayNumbers = 1;
const displayingNumbers = 2;
const enteringNumbers = 3;
const completed = 4;

var digitIndex = 0;
var myVar = null;

export default class ShortTermMemory extends Component {
    static getDerivedStateFromProps(props, state) {
        if (state.index === props.index) {
            return null;
        }

        return {
            index: props.index,
            innerStep: displayNumbers,
            input: ["", "", "", "", "", "", "", "", ""],
            inputIndex: -1,
            timerIndex: 0
        };
    }

    constructor(props) {
        super(props);
        this.buttonClick = this.buttonClick.bind(this);
        this.interceptClick = this.interceptClick.bind(this);
        this.textOnFocus = this.textOnFocus.bind(this);
        this.state = {
            index: 0,
            innerStep: displayNumbers,
            input: ["", "", "", "", "", "", "", "", ""],
            inputIndex: -1
        };
    }

    componentDidMount() {
        this.afterUpdate();
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    componentWillUnmount() {
        clearTimeout(myVar);
    }

    setNumbers(numbers) {
        try {
            const timerIndex = this.state.timerIndex;

            if (timerIndex === 99) {
                clearTimeout(myVar);
                this.setState({ innerStep: enteringNumbers, inputIndex: 0, timerIndex: 100 });
            } else if (timerIndex % 11 === 0) {
                const input = this.state.input;
                input[digitIndex] = numbers[digitIndex];
                this.setState({ input: input, timerIndex: timerIndex + 1 });
            } else if (timerIndex % 11 === 10) {
                const input = this.state.input;
                input[digitIndex++] = "";
                this.setState({ input: input, timerIndex: timerIndex + 1 });
            } else {
                this.setState({ timerIndex: timerIndex + 1 });
            }
        } catch (e) {
            clearTimeout(myVar);
        }
    }

    displayNumbers(numbers, devMode) {
        this.setState({ timerIndex: 0 });
        digitIndex = 0;
        myVar = setInterval(this.setNumbers.bind(this, numbers), devMode ? 20 : 100);
    }

    afterUpdate() {
        this.props.setInterceptClick(this.interceptClick);

        if (this.state.innerStep === displayNumbers) {
            this.setState({ innerStep: displayingNumbers });
            this.displayNumbers(this.props.digits, this.props.devMode);
        }
    }

    buttonClick(type) {
        const innerStep = this.state.innerStep;

        if (innerStep >= enteringNumbers) {
            const input = this.state.input;
            let inputIndex = this.state.inputIndex;

            input[inputIndex++] = type;

            if (inputIndex === 9) {
                inputIndex = 8;
            }

            const temp = { input: input, inputIndex: inputIndex };

            let done = true;

            for (let i = 0; i < 9; i++) {
                if (input[i] === "") {
                    done = false;
                    break;
                }
            }

            if (done) {
                temp.innerStep = completed;
            }

            this.setState(temp);

            if (temp.innerStep === completed) {
                this.props.clearDisableNext();
            }
        }
    }

    interceptClick(type) {
        if (type === "next") {
            let count = 0;
            const input = this.state.input;
            const digits = this.props.digits;

            for (let k = 0; k < 9; k++) {
                const s = digits.substring(k, k + 1);
                if (input[k] === s) {
                    count++;
                }
            }

            this.props.next({ response: count.toString() });
            return true;
        }

        return false;
    }

    textOnFocus(e, index) {
        e.target.blur();
        this.setState({ inputIndex: index });
    }

    render() {
        const progressStyle = {
            width: `${this.props.index * (100 / pageData.shortTermMemoryTestPages)}%`
        };

        const disabled = this.state.innerStep >= enteringNumbers ? "" : "disabled";

        return (
            <div className="test-page-content-inner test-page-short-term-memory">
                <div className="test-content">
                    <NumKeyPad buttonClick={this.buttonClick} />
                    <TextEntry input={this.state.input} inputIndex={this.state.inputIndex} onFocus={this.textOnFocus} disabled={disabled} />
                    <div className="progress">
                        <div className="progress-bar progress-bar-striped" role="progressbar" style={progressStyle} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" />
                    </div>
                </div>
            </div>
        );
    }
}
